module.exports = __webpack_public_path__ + "static/media/cart.352bd688.svg";